// src/components/store/sections/testimonials/TestimonialV90GlassfloatingFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV90GlassfloatingFuchsiaGlow(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={90}
      archKey="glass_floating"
      archLabel="Frosted Glass Reviews"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
